// WithEditMessage.js
'use strict';
import { connect } from 'react-redux';

import {
  FEATURE_EDIT_POST,
  JWT_SCOPE_MESSAGE_EDIT,
} from '../RemoteConfigKeys.js';

import WithEditMessage from '../component/WithEditMessage.jsx';

import openMessageEditor from '../action/openMessageEditor.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getMeData from '../selector/getMeData.js';
import getMessageData from '../selector/getMessageData.js';
import getIsPermissionMatched from '../selector/getIsPermissionMatched.js';

const mapStateToProps = (state, { messageId }) => {
  return {
    meId: getMeData(state, 'id'),
    senderId: getMessageData(state, messageId, 'senderId'),
    isEditMessageEnabled: getRemoteConfigData(state, FEATURE_EDIT_POST),
    isEditPermissionMatched: getIsPermissionMatched(
      state,
      JWT_SCOPE_MESSAGE_EDIT
    ),
  };
};
const mapDispatchToProps = dispatch => {
  return {
    openMessageEditor: data => dispatch(openMessageEditor(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithEditMessage);
